import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';

export const ButtonBar = ({
  primaryButtonLabel,
  primaryButtonDisabled,
  backButtonLabel,
  omitBackButtonIcon,
  onPrimaryButtonClick,
  onCancelClick,
  onBackClick,
}: {
  primaryButtonLabel: string;
  primaryButtonDisabled?: boolean;
  backButtonLabel?: string;
  omitBackButtonIcon?: boolean;
  onPrimaryButtonClick: () => void;
  onCancelClick: () => void;
  onBackClick?: () => void;
}) => {
  const { t } = useTranslation('phone');

  return (
    <div
      css={css`
        display: flex;
        justify-content: ${onBackClick ? 'space-between' : 'flex-end'};
        margin-top: auto;
        padding: 16px 32px 32px 32px;
      `}
    >
      {onBackClick && (
        <Button
          size='large'
          iconName={omitBackButtonIcon ? undefined : 'back'}
          variant='tertiary'
          onClick={onBackClick}
        >
          {!!backButtonLabel ? backButtonLabel : t('Back')}
        </Button>
      )}
      <div
        css={css`
          display: flex;
          gap: ${theme.spacing(2)};
        `}
      >
        <Button size='large' variant='secondary' onClick={onCancelClick}>
          {t('Cancel')}
        </Button>
        <Button size='large' disabled={primaryButtonDisabled} variant='primary' onClick={onPrimaryButtonClick}>
          {primaryButtonLabel}
        </Button>
      </div>
    </div>
  );
};
